"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = getColor;
function getColor(_ref) {
  var disabled = _ref.disabled,
    selected = _ref.selected,
    isTypography = _ref.isTypography;
  if (disabled) return 'disabled';
  return 'default';
}